import React, { FC } from 'react'
import useGoogleMaps from '@/hooks/useGoogleMaps'

interface Props {
  address?: string
  coordinates?: google.maps.GeocoderGeometry['location']
}

const GoogleMap: FC<Props> = ({ address, coordinates }) => {
  const { mapRef, setMarkerPosition } = useGoogleMaps({
    // Initialize with a center of the US
    center: { lat: 39, lng: -97 },
    zoom: 12,
    mapTypeControl: false,
    fullscreenControl: false,
    gestureHandling: null
  })

  setMarkerPosition({ address, coordinates })

  return <div ref={mapRef} id="map" className="google-map rounded-lg" />
}

export default GoogleMap
